// extracted by mini-css-extract-plugin
export default {"root":"OUt0oc2k0vmEpZGnfCkd","wrap":"DM7e0UAPOXep74YdBdkq","icon":"Ebrvkmn55n3RBdoY5lKO","copy":"HA1yrT4xfrbqEdSki0WQ","back":"ocMqjJ_pTUUHGIxW5fdR"};